import { ColDef, ValueFormatterParams } from '@ag-grid-community/core';

import { rawAttributeColumnRenderer } from '@shared/components/ag-raw-attribute-renderer/ag-raw-attribute-renderer';
import { ZERO_HYPHEN } from '@shared/constants/format';
import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';

import {
  defaultHeaderClass,
  defaultMinWidth,
  InMonthAdjustmentGridConfigContext,
} from './ima-grid-config-context';

export const getCostCategoryColumn = (ctx: InMonthAdjustmentGridConfigContext) => {
  const { attributeConfig } = ctx;
  const isPrimarySelected = !!attributeConfig.primaryAttribute.attribute_name;
  const isSecondarySelected = !!attributeConfig.secondaryAttribute.attribute_name;
  const headerName = 'Cost Category' + (isPrimarySelected ? '' : ' *');

  return {
    cellClass: getCellClassForGroups,
    field: 'cost_category_name',
    headerClass: defaultHeaderClass,
    headerName,
    headerTooltip: headerName,
    valueFormatter: (params: ValueFormatterParams) => params.value || ZERO_HYPHEN,
    ...rawAttributeColumnRenderer(
      attributeConfig,
      'cost_category_name',
      isSecondarySelected ? 2 : isPrimarySelected ? 1 : 0,
      {
        maxWidth: 320,
        minWidth: defaultMinWidth,
        offset: 60,
      }
    ),
    minWidth: defaultMinWidth,
    pinned: !isPrimarySelected ? 'left' : undefined,
  } satisfies ColDef;
};
